<form [formGroup]="form">
  <div class="buttonWrapper stackingContainer" [class.stackingLocked]="lockStackingAndSupport">
    <gl-checkbox data-ctx="checkbox-stacking" [disabled]="lockStackingAndSupport" [ngModel]="stacking" [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onStacking()">{{ 'stack' | translate }}
    </gl-checkbox>
    @if (stacking) {
      <div class="inputRow">
        <span>{{ 'stack_quantity' | translate }}:</span>
        <gl-input-container>
          <input data-ctx="input-stack-quantity" type="number" normal-input formControlName="stackQuantity" min="1" />
        </gl-input-container>
      </div>
    }
  </div>
  @if (stacking) {
    <div class="buttonWrapper">
      <gl-checkbox data-ctx="checkbox-weight-of-floors" [ngModel]="weightOfFloors"
        [ngModelOptions]="{ standalone: true }" (ngModelChange)="onWeightOfFloors()">{{ 'weight_of_floors' | translate
        }}
      </gl-checkbox>
      <div class="inputRow">
        <span>{{ 'specify_max_weight' | translate }}:</span>
        <gl-input-container>
          <input data-ctx="input-max-weight" type="number" normal-input formControlName="maxWeight" />
        </gl-input-container>
      </div>
    </div>
    <div class="buttonWrapper">
      <gl-checkbox data-ctx="checkbox-along-floor" formControlName="alongFloor"
        [defaultChecked]="defaultOptions?.alongFloor">
        {{ 'stack_along_floor' | translate }}
      </gl-checkbox>
    </div>
  }
  @if (groupData.loadType !== 1 && groupData.loadType !== 2) {
    <div class="buttonWrapper">
      <gl-checkbox data-ctx="checkbox-loads-to-stack" [disabled]="!(loadsGroups.length > 0)"
        [ngModel]="chooseLoadsToStack" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onChooseLoadsToStack()">{{
        'choose_loads_to_stack' | translate }}
      </gl-checkbox>
      <div class="inputRow">
        <gl-select data-ctx="select-load-to-stack" formControlName="load" [isDisabled]="!(loadsGroups.length > 0)">
          @for (group of loadsGroups; track group) {
            <gl-option [value]="group.id" [label]="group.nameTranslated" [loadType]="true"
              class="loadOption">
              <gl-checkbox [defaultChecked]="checkboxLoads[group.id]" [ngModel]="checkboxLoads[group.id]"
                [ngModelOptions]="{ standalone: true }" (ngModelChange)="setStackGroup(group.id)">
                <div class="groupColor" [ngStyle]="{ 'background-color': getColor(group) }"></div>
                {{ group.nameTranslated }}
              </gl-checkbox>
            </gl-option>
          }
        </gl-select>
      </div>
    </div>
  }
  @if (groupData.loadType !== 1 && groupData.loadType !== 2) {
    <div class="buttonWrapper percentageContainer" [class.stackingLocked]="lockStackingAndSupport">
      <gl-checkbox data-ctx="checkbox-pct" [disabled]="lockStackingAndSupport" [ngModel]="specifyPercentageOfSupport" [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onSpecifyPercentageOfSupport()">{{ 'specify_percentage_of_support' | translate }}
      </gl-checkbox>
      <div class="inputRow">
        <gl-slider data-ctx="slider-pct" [unit]="'%'" [max]="100" [min]="50" [isDisabled]="lockStackingAndSupport"
        formControlName="supportPercentage" class="supportPercentage"></gl-slider>
      </div>
    </div>
  }

</form>